import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=1e1e4b78&scoped=true&"
import script from "./MoreInformation.vue?vue&type=script&lang=js&"
export * from "./MoreInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e4b78",
  null
  
)

export default component.exports